import React from 'react';
import useGoogleAnalytics from './useGoogleAnalytics';

const Tracker = props => {
    useGoogleAnalytics();
    return <></>
}

export default Tracker;